import { useTranslations } from '@vocab/react';
import { AccordionItem, IconPeople } from 'braid-design-system';
import { useState } from 'react';

import CategoryGroupCard from 'src/components/atoms/CategoryGroupCard/CategoryGroupCard';
import { getPagePaths } from 'src/core/domain/pages';
import { useConfig } from 'src/provider/config';
import { useGroup } from 'src/provider/group';
import { usePage } from 'src/provider/page';

import translations from './.vocab';

import * as styles from './Sidebar.css';

export default () => {
  const { t } = useTranslations(translations);
  const [expanded, setExpanded] = useState(true);
  const { countryCode, language } = useConfig();

  const {
    pageState: { pageName, groupId: selectedGroupId },
    pageDispatch,
  } = usePage();
  const {
    groupState: { sideBarCategory },
  } = useGroup();

  const categoryGroupLabel = t(`top-${countryCode}-groups`);
  const showTopGroup = t('show-top-groups');

  return (
    <AccordionItem
      label={categoryGroupLabel}
      id="top-groups"
      icon={
        <span style={{ paddingRight: '10px' }}>
          <IconPeople />
        </span>
      }
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      {sideBarCategory.map(
        ({ categoryId, name: categoryName, groupId, memberCount, url }) => (
          <a
            key={categoryId}
            href={url}
            className={
              pageName === 'CommunityGroupDetails' &&
              categoryId === selectedGroupId
                ? styles.SelectedGroupThreadsSidebar
                : styles.GroupThreadsSidebar
            }
            onClick={() => {
              pageDispatch({ type: 'IS_LOADING' });
              pageDispatch({
                type: 'SET_GROUP_ID',
                payload: { groupId: categoryId },
              });
            }}
            data-testid={`sidebar-group-${categoryId}`}
          >
            <CategoryGroupCard
              key={groupId}
              category={categoryName}
              numberFollower={memberCount.label}
            />
          </a>
        ),
      )}
      <a
        href={
          getPagePaths({ language, queryParams: { type: 'top-groups' } })
            .CommunityGroups
        }
        className={styles.SidebarLinks}
      >
        {showTopGroup}
      </a>
    </AccordionItem>
  );
};
